/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES 企業の管理画面用 API
 * PR TIMES 企業の管理画面で使うAPI。basePathは今後変わる事も想定している。
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  GetPressKitResponse,
  GetS3PutPresignedUrlResponse,
  ModelError,
  PostPressKitBody,
  PostPressKitResponse,
} from '../models';
import {
    GetPressKitResponseFromJSON,
    GetPressKitResponseToJSON,
    GetS3PutPresignedUrlResponseFromJSON,
    GetS3PutPresignedUrlResponseToJSON,
    ModelErrorFromJSON,
    ModelErrorToJSON,
    PostPressKitBodyFromJSON,
    PostPressKitBodyToJSON,
    PostPressKitResponseFromJSON,
    PostPressKitResponseToJSON,
} from '../models';

export interface GetPressKitS3PresignedUrlRequest {
    target: GetPressKitS3PresignedUrlTargetEnum;
}

export interface PostPressKitRequest {
    postPressKitBody?: PostPressKitBody;
}

/**
 * 
 */
export class PressKitApi extends runtime.BaseAPI {

    /**
     * PressKit全体のデータを取得するAPI
     * Get overall data for PressKit
     */
    async getPressKitRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPressKitResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/press_kit`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPressKitResponseFromJSON(jsonValue));
    }

    /**
     * PressKit全体のデータを取得するAPI
     * Get overall data for PressKit
     */
    async getPressKit(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPressKitResponse> {
        const response = await this.getPressKitRaw(initOverrides);
        return await response.value();
    }

    /**
     * プレスキット用のS3へオブジェクトをPUTするための署名付きURLを取得するAPI
     * Get S3 Pre-Signed URL to upload object for PressKit
     */
    async getPressKitS3PresignedUrlRaw(requestParameters: GetPressKitS3PresignedUrlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetS3PutPresignedUrlResponse>> {
        if (requestParameters.target === null || requestParameters.target === undefined) {
            throw new runtime.RequiredError('target','Required parameter requestParameters.target was null or undefined when calling getPressKitS3PresignedUrl.');
        }

        const queryParameters: any = {};

        if (requestParameters.target !== undefined) {
            queryParameters['target'] = requestParameters.target;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/press_kit/s3_put_presigned_url`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetS3PutPresignedUrlResponseFromJSON(jsonValue));
    }

    /**
     * プレスキット用のS3へオブジェクトをPUTするための署名付きURLを取得するAPI
     * Get S3 Pre-Signed URL to upload object for PressKit
     */
    async getPressKitS3PresignedUrl(requestParameters: GetPressKitS3PresignedUrlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetS3PutPresignedUrlResponse> {
        const response = await this.getPressKitS3PresignedUrlRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * PressKit全体のデータを更新するAPI
     * Update overall data for PressKit
     */
    async postPressKitRaw(requestParameters: PostPressKitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PostPressKitResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/press_kit`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PostPressKitBodyToJSON(requestParameters.postPressKitBody),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PostPressKitResponseFromJSON(jsonValue));
    }

    /**
     * PressKit全体のデータを更新するAPI
     * Update overall data for PressKit
     */
    async postPressKit(requestParameters: PostPressKitRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PostPressKitResponse> {
        const response = await this.postPressKitRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
  * @export
  * @enum {string}
  */
export enum GetPressKitS3PresignedUrlTargetEnum {
    Logos = 'logos',
    Images = 'images',
    GuidelineFiles = 'guideline_files',
    Documents = 'documents',
    Profiles = 'profiles',
    DocumentsThumbnail = 'documents_thumbnail',
    GuidelineFilesThumbnail = 'guideline_files_thumbnail'
}
